import { Component, effect, Input, OnDestroy, Signal } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NgIf } from '@angular/common';
import { MenuService } from '../menu/services/menu.service';
import { FormsModule } from '@angular/forms';
import { ThemeService } from '../../services/theme/theme.service';
import { ThemeEnum } from '../../services/theme/models/enums/theme.enum';
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from '@angular/router';
import { MeService } from '../../services/me/me.service';
import { UserDto } from '../../services/user/models/user.dto';
import { AuthService } from '../../services/auth/auth.service';
import { ButtonComponent } from '../button/button.component';
import { OutsideClickDirective } from '../../directives/outside-click/outside-click.directive';
import { filter, map, Subscription, switchMap } from "rxjs";
import { MenuComponent } from '../menu/menu.component';
import { Menu } from '../menu/models/menu';
import { InitialsPipe } from '../../pipes/initials.pipe';
import { appBranding } from '../../../../themes/assets/app-branding';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [
    IconComponent,
    NgIf,
    FormsModule,
    RouterLink,
    ButtonComponent,
    OutsideClickDirective,
    MenuComponent,
    InitialsPipe
  ]
})
export class HeaderComponent implements OnDestroy {

  constructor(
    router: Router,
    route: ActivatedRoute,
    private readonly meService: MeService,
    private readonly menuService: MenuService,
    private readonly authService: AuthService,
    private readonly themeService: ThemeService,
  ) {
    this.routerSubscription = router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => route),
      map(route => {
        while (route.firstChild)
          route = route.firstChild;

        return route;
      }),
      switchMap(route => route.data)
    ).subscribe();

    effect(() => {
      this.user = meService.me();
    });
  }

  @Input({ required: true })
  public menus: Menu[] = [];

  public timer: ReturnType<typeof setTimeout> | null = null;

  public open = false;

  public shortMode: Signal<boolean> = this.menuService.short;

  public theme: Signal<ThemeEnum> = this.themeService.theme;

  public me: Signal<UserDto | null> = this.meService.me;

  public user: UserDto | null = null;

  public readonly appBranding = appBranding;

  protected readonly themeEnum = ThemeEnum;

  protected readonly routerSubscription: Subscription;

  public ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  public toggleTheme(): void {
    this.themeService.theme = this.theme() === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;
  }

  public setShortMode(): void {
    this.menuService.short = false;
  }

  public async logout(): Promise<void> {
    await this.authService.logout();
  }

}
